import { render, staticRenderFns } from "./SurveyTableCard.vue?vue&type=template&id=f49b57ce"
import script from "./SurveyTableCard.vue?vue&type=script&lang=js"
export * from "./SurveyTableCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports